import { Component } from '@angular/core';

@Component({
  selector: 'app-project-generator',
  templateUrl: './project-generator.component.html',
  styleUrls: ['./project-generator.component.css'],
  standalone: false
})
export class ProjectGeneratorComponent {
  readonly pluginUrl = 'https://github.com/CVNA-Wholesale/Wholesale-Claude-Marketplace/blob/master/plugins/platform/README.md';
}
